(function(){
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var SNX=window.SNX=window.SNX||{};
  function grp(s,sep){return s.replace(/\B(?=(\d{3})+(?!\d))/g,sep);}
  SNX.money=function(c){
    var f=SNX.moneyFormat||'${{amount}}';var a=(Number(c)/100).toFixed(2).split('.');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/,function(m,k){
      if(k==='amount_no_decimals')return grp(a[0],',');
      if(k==='amount_with_comma_separator')return grp(a[0],'.')+','+a[1];
      if(k==='amount_no_decimals_with_comma_separator')return grp(a[0],'.');
      return grp(a[0],',')+'.'+a[1];
    });
  };
  SNX.updateCount=function(n){document.querySelectorAll('[data-snx-count]').forEach(function(el){el.textContent=n;el.setAttribute('data-count',n);});};
  SNX.add=function(id,qty,btn,msg){
    var label=btn?btn.innerHTML:'';
    if(btn){btn.disabled=true;btn.textContent='Adding…';}
    if(msg){msg.textContent='';}
    return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:Math.max(1,parseInt(qty,10)||1)}]})})
      .then(function(r){return r.json().then(function(d){if(!r.ok){throw d;}return d;});})
      .then(function(){return fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});})
      .then(function(cart){
        SNX.updateCount(cart.item_count);
        if(btn){btn.textContent='Added ✓';}
        if(msg){msg.innerHTML="Added to your cart · <a href='"+root+"cart' style='text-decoration:underline;color:#111'>View cart</a>";}
        setTimeout(function(){if(btn){btn.innerHTML=label;btn.disabled=false;}},2200);
      })
      .catch(function(e){
        if(btn){btn.innerHTML=label;btn.disabled=false;}
        if(msg){msg.textContent=(e&&(e.description||e.message))||'Could not add to cart. Please try again.';}
      });
  };
  function pdpChange(w){
    var data=w.querySelector('[data-snx-variants]');if(!data)return;
    var variants=JSON.parse(data.textContent);
    var sel=Array.prototype.map.call(w.querySelectorAll('[data-snx-options] fieldset'),function(fs){var c=fs.querySelector('input:checked');return c?c.value:null;});
    var v=variants.find(function(x){return x.options.every(function(o,i){return o===sel[i];});});
    var btns=w.querySelectorAll('[data-snx-atc-btn]');
    if(!v){btns.forEach(function(b){b.disabled=true;b.textContent='Unavailable';});return;}
    w.querySelector('input[name=id]').value=v.id;
    w.querySelectorAll('[data-snx-price]').forEach(function(el){el.textContent=SNX.money(v.price);});
    w.querySelectorAll('[data-snx-compare]').forEach(function(el){el.textContent=(v.compare_at_price&&v.compare_at_price>v.price)?SNX.money(v.compare_at_price):'';});
    var st=w.querySelector('[data-snx-stock]');
    if(st){st.classList.toggle('is-out',!v.available);st.querySelector('span').textContent=v.available?st.getAttribute('data-in'):st.getAttribute('data-out');}
    btns.forEach(function(b){b.disabled=!v.available;b.textContent=v.available?'Add to Cart':'Sold Out';});
    if(v.featured_image){var m=w.querySelector('[data-snx-main]');if(m){m.src=v.featured_image.src;m.removeAttribute('srcset');}}
    if(window.history&&history.replaceState){history.replaceState(null,'','?variant='+v.id);}
  }
  document.addEventListener('click',function(e){
    var q=e.target.closest('[data-snx-qty]');
    if(q){var i=q.parentNode.querySelector('input');var n=(parseInt(i.value,10)||1)+parseInt(q.getAttribute('data-snx-qty'),10);i.value=Math.max(1,Math.min(n,parseInt(i.max,10)||99));return;}
    var t=e.target.closest('[data-snx-thumb]');
    if(t){var g=t.closest('[data-snx-gallery]');var m=g.querySelector('[data-snx-main]');if(m){m.src=t.getAttribute('data-snx-thumb');m.removeAttribute('srcset');}
      g.querySelectorAll('[data-snx-thumb]').forEach(function(b){b.classList.toggle('is-active',b===t);});
      var z=g.querySelector('.is-zoom');if(z){z.classList.remove('is-zoom');}return;}
    var s=e.target.closest('[data-snx-submit]');
    if(s){var f=document.getElementById(s.getAttribute('data-snx-submit'));if(f){if(f.requestSubmit){f.requestSubmit();}else{f.dispatchEvent(new Event('submit',{cancelable:true,bubbles:true}));}}return;}
    var tb=e.target.closest('[data-snx-tab]');
    if(tb){var tw=tb.closest('[data-snx-tabs]');tw.querySelectorAll('[data-snx-tab]').forEach(function(b){var on=b===tb;b.setAttribute('aria-selected',on?'true':'false');var p=document.getElementById(b.getAttribute('aria-controls'));if(p){p.hidden=!on;}});return;}
    var sc=e.target.closest('[data-snx-scroll]');
    if(sc){var l=sc.closest('[data-snx-reviews]').querySelector('.snx-revs');var c=l.querySelector('.snx-rev');l.scrollBy({left:(c?c.offsetWidth+20:300)*parseInt(sc.getAttribute('data-snx-scroll'),10),behavior:'smooth'});return;}
    var bg=e.target.closest('[data-snx-burger]');
    if(bg){var d=document.querySelector('[data-snx-drawer]');if(d){var o=d.classList.toggle('is-open');bg.setAttribute('aria-expanded',o?'true':'false');}return;}
    var zm=e.target.closest('[data-snx-zoom]');
    if(zm&&window.matchMedia('(hover: hover)').matches){zm.classList.toggle('is-zoom');}
  });
  document.addEventListener('mousemove',function(e){
    var z=e.target.closest&&e.target.closest('[data-snx-zoom].is-zoom');if(!z)return;
    var r=z.getBoundingClientRect();var img=z.querySelector('img');if(!img)return;
    img.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%';
  });
  document.addEventListener('change',function(e){
    var sel=e.target.closest('select[data-snx-variant]');
    if(sel){var o=sel.options[sel.selectedIndex];var w=sel.closest('[data-snx-product]');
      w.querySelectorAll('[data-snx-price]').forEach(function(el){el.textContent=o.getAttribute('data-price');});
      w.querySelectorAll('[data-snx-compare]').forEach(function(el){el.textContent=o.getAttribute('data-compare')||'';});return;}
    var r=e.target.closest('[data-snx-options] input');
    if(r){pdpChange(r.closest('[data-snx-product]'));}
  });
  document.addEventListener('submit',function(e){
    var f=e.target.closest('form[data-snx-atc]');if(!f)return;e.preventDefault();
    var id=f.querySelector('input[name=id], select[name=id]');var q=f.querySelector('[name=quantity]');
    SNX.add(id.value,q?q.value:1,f.querySelector('[type=submit]'),f.querySelector('.snx-msg'));
  });
  function initRot(el){
    if(el._snx)return;el._snx=1;
    var slides=el.querySelectorAll('.snx-bs__slide');var dots=el.querySelector('.snx-dots');var i=0,t;
    if(!dots)return;
    if(slides.length<2){dots.hidden=true;return;}
    dots.innerHTML='';
    slides.forEach(function(s,k){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Show product '+(k+1));b.addEventListener('click',function(){go(k);restart();});dots.appendChild(b);});
    function go(k){i=(k+slides.length)%slides.length;slides.forEach(function(s,n){s.classList.toggle('is-active',n===i);});dots.querySelectorAll('button').forEach(function(b,n){b.classList.toggle('is-active',n===i);b.setAttribute('aria-current',n===i?'true':'false');});}
    function restart(){clearInterval(t);if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){t=setInterval(function(){go(i+1);},parseInt(el.getAttribute('data-interval'),10)||5000);}}
    el.addEventListener('mouseenter',function(){clearInterval(t);});
    el.addEventListener('mouseleave',restart);
    el.addEventListener('focusin',function(){clearInterval(t);});
    go(0);restart();
  }
  function initSticky(){
    var bar=document.querySelector('[data-snx-sticky]');var tgt=document.querySelector('[data-snx-sticky-target]');
    if(!bar||!tgt||bar._snx||!('IntersectionObserver' in window))return;bar._snx=1;
    new IntersectionObserver(function(en){bar.classList.toggle('is-visible',!en[0].isIntersecting&&en[0].boundingClientRect.top<0);}).observe(tgt);
  }
  function init(){document.querySelectorAll('[data-snx-rotator]').forEach(initRot);initSticky();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();